import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=f7ab38a2&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=f7ab38a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ab38a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7ab38a2')) {
      api.createRecord('f7ab38a2', component.options)
    } else {
      api.reload('f7ab38a2', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=f7ab38a2&scoped=true&", function () {
      api.rerender('f7ab38a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Header/menu.vue"
export default component.exports